import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Grid, Button, Icon } from 'semantic-ui-react';
import POSButton from 'PointOfSale/modules/common/component/Button';

import 'PointOfSale/styles/components/button.less';
import 'PointOfSale/styles/components/input.less';
import 'PointOfSale/styles/components/servingOptions.less';

const AutoServe = props => {
  const { timeDelay, handleDecrement, handleIncrement } = props;
  const iconClass = classNames('pos-button-icon');

  return (
    <Grid.Column className="time-delay">
      <div className="text-center text-primary">
        <label>Time delay</label>
      </div>
      <POSButton label={timeDelay + ' seconds'} disabled fluid />
      <div className="servingOption-increment">
        <Button className="pos-circle-button" onClick={handleDecrement}>
          <Icon name="minus" size="large" className={iconClass} />
        </Button>
        <Button className="pos-circle-button" onClick={handleIncrement}>
          <Icon name="plus" size="large" className={iconClass} />
        </Button>
      </div>
    </Grid.Column>
  );
};

AutoServe.propTypes = {
  timeDelay: PropTypes.number,
  handleDecrement: PropTypes.func,
  handleIncrement: PropTypes.func,
};
AutoServe.defaultProps = {
  timeDelay: 5,
};
export default AutoServe;



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/servingOptionCategory/component/Autoserve.js